'use client';

import { GameStatsTable } from '@/components/organisms';
import { GameStatsTableSkeleton } from '@/components/organisms/skeletons/GameStatsTableSkeleton';
import { usePlayerStatsQuery } from '@/hooks/player/usePlayerStatsQuery';

interface GameStatsTableProps {
	teamLeagueId: string;
	seasonId: string;
	playerId: string;
}

export const GameStatsTableWrapper = ({ teamLeagueId, seasonId, playerId }: GameStatsTableProps) => {
	const { data: playerStats, isFetching } = usePlayerStatsQuery(teamLeagueId, seasonId, playerId);

	if (isFetching || !playerStats) {
		return <GameStatsTableSkeleton />;
	}

	if (playerStats?.statusCode !== 200) {
		return null;
	}

	return <GameStatsTable divisions={playerStats.data.divisionAnalytics.divisions!} />;
};
